

















import { Page } from '@/core/components/controls';
import { Component, Prop } from 'vue-property-decorator';
import { latLng, LatLng } from 'leaflet';
import { getTableCaption } from '@/core/components/table';
import Map from '@/core/components/map';
import { LocationHistoryRecord, MapMarker, Site } from '@/dto';
import { GroupedLocationHistory, LocationHistoryArgs } from './types';
import { ContextsState } from '@/store';
import { debounce } from 'lodash';
import config from '@/config';

@Component({
    components: {
        Map,
    },
})
export default class LocationHistoryMap extends Page {
    @Prop({ default: () => ({}) }) public args!: LocationHistoryArgs;
    public channels: any[] = [];
    public center: LatLng = latLng(0, 0);

    public vehicleMarkers: MapMarker[] = [];
    public siteMarkers: MapMarker[] = [];
    private resizeDebounced = debounce(
        this.onResize.bind(this),
        config.events.mapResizeDelay
    );

    public get pageName(): string {
        return getTableCaption('location-history-map');
    }

    public resized() {
        this.resizeDebounced();
    }

    private onResize() {
        const map = this.$refs.map as Map;
        if (map) {
            map.refresh();
        }
    }

    private async mounted() {
        const currentTime = new Date(ContextsState.current!.currentTime);
        currentTime.setDate(currentTime.getDate() - 7);
        const lastWeek = new Date(currentTime);

        const _center = { count: 0, sumLatitude: 0, sumLongitude: 0 };

        this.args.locationHistory.forEach((group: GroupedLocationHistory) => {
            const lastPosition = group.items[0];
            const lat = +lastPosition.Latitude.toFixed(6);
            const lng = +lastPosition.Longitude.toFixed(6);

            const path = group.items
                .filter(
                    (point: LocationHistoryRecord) =>
                        new Date(point.NavTime) > lastWeek
                )
                .map((point: LocationHistoryRecord) =>
                    latLng(point.Latitude, point.Longitude)
                );

            _center.count += 1;
            _center.sumLatitude += lat;
            _center.sumLongitude += lng;

            this.addVehicleMarker(latLng(lat, lng), group.key, path);
        });

        this.center = latLng(
            _center.sumLatitude / _center.count,
            _center.sumLongitude / _center.count
        );

        this.args.sites.forEach((site: Site) => {
            if (site.isVisible) {
                this.addSiteMarker(latLng(site.latitude, site.longitude), site);
            }
        });
    }

    private addVehicleMarker(coords: LatLng, name: string, path: LatLng[]) {
        const marker = this.vehicleMarkers.find(
            x => x.latLng.lat === coords.lat && x.latLng.lng === coords.lng
        );
        if (marker === undefined) {
            this.vehicleMarkers.push({
                latLng: coords,
                info: {
                    type: 'vehicle',
                    name: [name],
                },
                path,
            });
        } else {
            const info = marker?.info.name || [];
            if (info.indexOf(name) === -1) {
                info.push(name);
            }
        }
    }

    private addSiteMarker(coords: LatLng, markerInfo: any) {
        const marker = this.siteMarkers.find(
            x => x.latLng.lat === coords.lat && x.latLng.lng === coords.lng
        );
        if (marker === undefined) {
            this.siteMarkers.push({
                latLng: coords,
                info: [markerInfo.name],
            });
        } else {
            const info = marker?.info || [];
            if (info.indexOf(markerInfo.name) === -1) {
                info.push(markerInfo.name);
            }
        }
    }
}
